<div class="create-request-container">
  <div class="form-header">
    <h1>{{ titleText }}</h1>
  </div>

  <form [formGroup]="requestForm" (ngSubmit)="onSubmit()" class="request-form">
    <!-- Основная информация -->
    <div class="form-section">
      <h2>{{ mainInfoTitleText }}</h2>
      
      <div class="form-row">
        <div class="form-group">
          <label>
            {{ rateTypeText }} <span class="required">{{ requiredText }}</span>
          </label>
          <select formControlName="rateType" class="form-control">
            <option *ngFor="let rt of rateTypeOptions" [value]="rt.value">{{ rt.label }}</option>
          </select>
          <div *ngIf="requestForm.get('rateType')?.invalid && requestForm.get('rateType')?.touched" class="error-message">
            {{ requiredFieldText }}
          </div>
        </div>
      </div>

      <!-- Маршрут -->
      <div class="route-section">
        <h3 class="route-title">{{ routeText }}</h3>
        <div class="route-container">
          <!-- Откуда -->
          <div class="route-point route-from">
            <div class="route-label">{{ fromText }}</div>
            <div class="form-group">
              <label>
                {{ fromCountryText }} <span class="required">{{ requiredText }}</span>
              </label>
              <app-country-select formControlName="fromCountryId" [countries]="countries" [placeholder]="fromCountryText"></app-country-select>
              <div *ngIf="requestForm.get('fromCountryId')?.invalid && requestForm.get('fromCountryId')?.touched" class="error-message">
                {{ requiredFieldText }}
              </div>
            </div>
            <div class="form-group">
              <label>
                {{ fromCityText }} <span class="required">{{ requiredText }}</span>
              </label>
              <input type="text" formControlName="fromCity" class="form-control" placeholder="{{ fromCityText }}" />
              <div *ngIf="requestForm.get('fromCity')?.invalid && requestForm.get('fromCity')?.touched" class="error-message">
                {{ requiredFieldText }}
              </div>
            </div>
          </div>

          <!-- Стрелка -->
          <div class="route-arrow">
            <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10 24H38M38 24L30 16M38 24L30 32" stroke="#005bbb" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>

          <!-- Куда -->
          <div class="route-point route-to">
            <div class="route-label">{{ toText }}</div>
            <div class="form-group">
              <label>
                {{ toCountryText }} <span class="required">{{ requiredText }}</span>
              </label>
              <app-country-select formControlName="toCountryId" [countries]="countries" [placeholder]="toCountryText"></app-country-select>
              <div *ngIf="requestForm.get('toCountryId')?.invalid && requestForm.get('toCountryId')?.touched" class="error-message">
                {{ requiredFieldText }}
              </div>
            </div>
            <div class="form-group">
              <label>
                {{ toCityText }} <span class="required">{{ requiredText }}</span>
              </label>
              <input type="text" formControlName="toCity" class="form-control" placeholder="{{ toCityText }}" />
              <div *ngIf="requestForm.get('toCity')?.invalid && requestForm.get('toCity')?.touched" class="error-message">
                {{ requiredFieldText }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="form-row">
        <div class="form-group">
          <label>
            {{ loadingDateText }} <span class="required">{{ requiredText }}</span>
          </label>
          <input type="date" formControlName="loadingDate" class="form-control" />
          <div *ngIf="requestForm.get('loadingDate')?.invalid && requestForm.get('loadingDate')?.touched" class="error-message">
            {{ requiredFieldText }}
          </div>
        </div>

        <div class="form-group">
          <label>
            {{ cargoCostText }} <span class="required">{{ requiredText }}</span>
          </label>
          <input type="number" formControlName="price" class="form-control" step="0.01" min="0" />
          <div *ngIf="requestForm.get('price')?.invalid && requestForm.get('price')?.touched" class="error-message">
            {{ requiredFieldText }}
          </div>
        </div>

        <div class="form-group">
          <label>
            {{ currencyText }} <span class="required">{{ requiredText }}</span>
          </label>
          <select formControlName="currencyId" class="form-control">
            <option value="">{{ currencyText }}</option>
            <option *ngFor="let currency of currencies" [value]="currency.id">
              {{ getCurrencyName(currency) }}
            </option>
          </select>
          <div *ngIf="requestForm.get('currencyId')?.invalid && requestForm.get('currencyId')?.touched" class="error-message">
            {{ requiredFieldText }}
          </div>
        </div>
      </div>
    </div>

    <!-- Продукты -->
    <div class="form-section">
      <div class="section-header">
        <h2>{{ productsText }}</h2>
        <button type="button" (click)="addProduct()" class="btn btn-secondary">
          {{ addProductText }}
        </button>
      </div>

      <div formArrayName="products" class="products-list">
        <div *ngFor="let product of products.controls; let i = index" [formGroupName]="i" class="product-item">
          <div class="product-header">
            <h3>{{ cargoPlaceLabelText }} {{ i + 1 }}</h3>
            <button *ngIf="products.length > 1" type="button" (click)="removeProduct(i)" class="btn btn-danger btn-sm">
              {{ removeProductText }}
            </button>
          </div>

          <div class="form-row">
            <div class="form-group">
              <label>
                {{ cargoTypeText }} <span class="required">{{ requiredText }}</span>
              </label>
              <select formControlName="cargoTypeId" class="form-control">
                <option value="">{{ cargoTypeText }}</option>
                <option *ngFor="let type of cargoTypes" [value]="type.id">
                  {{ getCargoTypeName(type) }}
                </option>
              </select>
              <div *ngIf="product.get('cargoTypeId')?.invalid && product.get('cargoTypeId')?.touched" class="error-message">
                {{ requiredFieldText }}
              </div>
            </div>

            <div class="form-group tnved-group">
              <label>
                {{ tnvedCodeText }} <span class="required">{{ requiredText }}</span>
              </label>
              <input type="text" formControlName="tnvedCode" class="form-control" [placeholder]="tnvedCodeText" maxlength="20" />
              <a [href]="tnvedHintUrl" target="_blank" rel="noopener noreferrer" class="tnved-hint-link">{{ tnvedHintText }}</a>
              <div *ngIf="product.get('tnvedCode')?.invalid && product.get('tnvedCode')?.touched" class="error-message">
                {{ requiredText }}
              </div>
            </div>

            <div class="form-group">
              <label>
                {{ nameText }} <span class="required">{{ requiredText }}</span>
              </label>
              <input type="text" formControlName="name" class="form-control" [placeholder]="nameText" />
              <div *ngIf="product.get('name')?.invalid && product.get('name')?.touched" class="error-message">
                {{ requiredText }}
              </div>
            </div>
          </div>

          <!-- Переключатель: габариты или объем -->
          <div class="form-row">
            <div class="form-group">
              <label class="radio-group">
                <input type="radio" formControlName="useDimensions" [value]="true" />
                {{ useDimensionsText }}
              </label>
              <label class="radio-group">
                <input type="radio" formControlName="useDimensions" [value]="false" />
                {{ useVolumeText }}
              </label>
            </div>
          </div>

          <!-- Режим "Вес и габариты" -->
          <div *ngIf="product.get('useDimensions')?.value === true">
            <!-- Строка 1: вес, длина, ширина, высота -->
            <div class="form-row">
              <div class="form-group">
                <label>
                  {{ weightText }} <span class="required">{{ requiredText }}</span>
                </label>
                <input type="number" formControlName="weightKg" class="form-control" step="0.01" min="0.01" />
              </div>
              <div class="form-group">
                <label>
                  {{ lengthText }} <span class="required">{{ requiredText }}</span>
                </label>
                <input 
                  type="number" 
                  formControlName="lengthMm" 
                  class="form-control" 
                  min="1"
                  [class.is-invalid]="product.get('lengthMm')?.invalid && (product.get('lengthMm')?.touched || product.hasError('dimensionsRequired'))"
                />
                <div *ngIf="product.get('lengthMm')?.invalid && (product.get('lengthMm')?.touched || product.hasError('dimensionsRequired'))" class="error-message">
                  {{ requiredFieldText }}
                </div>
              </div>
              <div class="form-group">
                <label>
                  {{ widthText }} <span class="required">{{ requiredText }}</span>
                </label>
                <input 
                  type="number" 
                  formControlName="widthMm" 
                  class="form-control" 
                  min="1"
                  [class.is-invalid]="product.get('widthMm')?.invalid && (product.get('widthMm')?.touched || product.hasError('dimensionsRequired'))"
                />
                <div *ngIf="product.get('widthMm')?.invalid && (product.get('widthMm')?.touched || product.hasError('dimensionsRequired'))" class="error-message">
                  {{ requiredFieldText }}
                </div>
              </div>
              <div class="form-group">
                <label>
                  {{ heightText }} <span class="required">{{ requiredText }}</span>
                </label>
                <input 
                  type="number" 
                  formControlName="heightMm" 
                  class="form-control" 
                  min="1"
                  [class.is-invalid]="product.get('heightMm')?.invalid && (product.get('heightMm')?.touched || product.hasError('dimensionsRequired'))"
                />
                <div *ngIf="product.get('heightMm')?.invalid && (product.get('heightMm')?.touched || product.hasError('dimensionsRequired'))" class="error-message">
                  {{ requiredFieldText }}
                </div>
              </div>
            </div>
            <!-- Строка 2: количество, Общий вес (вычислено), Общий объем (вычислено) -->
            <div class="form-row">
              <div class="form-group">
                <label>
                  {{ quantityText }} <span class="required">{{ requiredText }}</span>
                </label>
                <input type="number" formControlName="quantity" class="form-control" min="1" step="1" />
                <div *ngIf="product.hasError('quantityRequired') && (product.touched || product.dirty)" class="error-message">
                  {{ requiredFieldMinOneText }}
                </div>
              </div>
              <div class="form-group">
                <label>{{ totalWeightCalculatedText }}</label>
                <input 
                  type="text" 
                  [value]="formatCalculatedWeight(getCalculatedTotalWeight(getProductFormGroup(i)))" 
                  class="form-control readonly-field" 
                  readonly 
                  [placeholder]="autoFilledPlaceholderText"
                />
              </div>
              <div class="form-group">
                <label>{{ totalVolumeCalculatedText }}</label>
                <input 
                  type="text" 
                  [value]="formatCalculatedVolume(getCalculatedTotalVolume(getProductFormGroup(i)))" 
                  class="form-control readonly-field" 
                  readonly 
                  [placeholder]="autoFilledPlaceholderText"
                />
              </div>
            </div>
          </div>

          <!-- Режим "Суммарные данные": Суммарный объем, Суммарный вес -->
          <div class="form-row" *ngIf="product.get('useDimensions')?.value === false">
            <div class="form-group">
              <label>
                {{ totalVolumeText }} <span class="required">{{ requiredText }}</span>
              </label>
              <input 
                type="number" 
                formControlName="volumeM3" 
                class="form-control" 
                step="0.0001"
                [class.is-invalid]="product.get('volumeM3')?.invalid && (product.get('volumeM3')?.touched || product.hasError('volumeRequired'))"
              />
              <div *ngIf="product.get('volumeM3')?.invalid && (product.get('volumeM3')?.touched || product.hasError('volumeRequired'))" class="error-message">
                {{ requiredFieldMinVolumeText }}
              </div>
            </div>
            <div class="form-group">
              <label>
                {{ totalWeightText }} <span class="required">{{ requiredText }}</span>
              </label>
              <input type="number" formControlName="totalWeightKg" class="form-control" step="0.01" min="0.01" />
            </div>
          </div>

          <!-- Общая ошибка валидации -->
          <div *ngIf="product.hasError('dimensionsRequired') && (product.touched || product.dirty)" class="error-message error-summary">
            {{ fillAllDimensionsWarningText }}
            <div style="font-size: 0.8rem; margin-top: 0.25rem; opacity: 0.8;">
              {{ lengthShortLabelText }}: {{ product.get('lengthMm')?.value || notFilledText }}, 
              {{ widthShortLabelText }}: {{ product.get('widthMm')?.value || notFilledText }}, 
              {{ heightShortLabelText }}: {{ product.get('heightMm')?.value || notFilledText }}
            </div>
          </div>
          <div *ngIf="product.hasError('volumeRequired') && product.get('useDimensions')?.value === false && (product.touched || product.dirty)" class="error-message error-summary">
            {{ fillTotalVolumeWarningText }}
          </div>
          <div *ngIf="product.hasError('totalWeightRequired') && product.get('useDimensions')?.value === false && (product.touched || product.dirty)" class="error-message error-summary">
            {{ fillTotalWeightWarningText }}
          </div>

          <div class="form-row">
            <div class="form-group checkbox-group">
              <label>
                <input type="checkbox" formControlName="isDangerous" />
                {{ isDangerousText }}
              </label>
            </div>

            <div class="form-group checkbox-group">
              <label>
                <input type="checkbox" formControlName="isOversized" />
                {{ isOversizedText }}
              </label>
            </div>

            <div class="form-group checkbox-group">
              <label>
                <input type="checkbox" formControlName="isNonStackable" />
                {{ isNonStackableText }}
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Сообщения об ошибках и успехе -->
    <div *ngIf="error" class="alert alert-error" style="white-space: pre-line;">
      {{ error }}
    </div>

    <div *ngIf="success" class="alert alert-success">
      {{ requestCreatedSuccessText }}
    </div>

    <div *ngIf="!isEditMode" class="form-section own-forwarder-section">
      <div class="form-row">
        <div class="form-group checkbox-group">
          <label>
            <input type="checkbox" formControlName="continueWithOwnForwarder" />
            {{ continueWithOwnForwarderText }}
          </label>
        </div>
      </div>
    </div>

    <!-- Кнопки -->
    <div class="form-actions">
      <button type="button" (click)="onCancel()" class="btn btn-secondary">
        {{ cancelText }}
      </button>
      <button type="button" (click)="onSubmitAsDraft()" [disabled]="submitting || !canSubmit || requestForm.get('continueWithOwnForwarder')?.value" class="btn btn-secondary">
        {{ saveAsDraftText }}
      </button>
      <button type="submit" [disabled]="submitting || !canSubmit" class="btn btn-primary">
        {{ submitting ? submittingText : submitText }}
      </button>
    </div>
  </form>
</div>
